import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

import { UserService } from 'src/app/services/shared/user.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { TerraUtils } from 'src/app/shared/TerraUtils';
import { ClientDetailsResponse } from 'src/app/account/my-account/model/agentDetailsResponse.model';
import { PersonalDetailsReqRes } from 'src/app/account/models/personalDetailsReqRes.model';
import { UserType } from 'src/app/account/login/UserType.enum';
import { ResourceService } from 'src/app/services/resource.service';
import { CountryModel } from 'src/app/shared/models/CountryModel';

@Component({
  selector: 'terra-personal-details-lp',
  templateUrl: './personal-details-lp.component.html',
  styleUrls: ['./personal-details-lp.component.scss']
})
export class PersonalDetailsLpComponent extends OnDestroyMixin implements OnInit {

  clientDetails: ClientDetailsResponse;

  pageForm: UntypedFormGroup;
  isSubmitted = false;
  formSubmitting = false;
  isGeneralServerError = false;
  generalServerErrorMessage: string = TerraUtils.consts.messages.GENERAL_SUBMIT_ERROR;

  allCountries = this.resourceService.allCountries;
  allStates = this.resourceService.allStates;
  countryCodes = TerraUtils.consts.countryCode;
  USCountryId = this.resourceService.getCountryByCode(this.countryCodes.US).id;



  get isOrganization() {
    if (this.clientDetails) {
      return !!this.clientDetails.organizationDetails;
    }
    return false;
  }

  @Input()
  set model(model: ClientDetailsResponse) {
    if (model && !this.clientDetails) {
      this.clientDetails = model;
    }
  }
  get model() {
    return this.clientDetails;
  }

  constructor(
    private fb: UntypedFormBuilder,
    private userService: UserService,
    private snackbarService: SnackbarService,
    private resourceService: ResourceService) {
      super();
  }

  ngOnInit() {
    this.generatePageForm();
    this.subscribeToCountryChange();

  }

  generatePageForm() {
    this.pageForm = this.fb.group({
      firstName: [this.clientDetails.firstName, Validators.required],
      lastName: [this.clientDetails.lastName, Validators.required],
      phone1: [this.clientDetails.phone1, Validators.required],
      countryId: [this.clientDetails.locationDetails ? this.clientDetails.locationDetails.countryId : null, !this.isOrganization ? [Validators.required] : []],
      stateName: [this.clientDetails.locationDetails ? this.clientDetails.locationDetails.stateName : null]
    });
    if (this.clientDetails.isClientKYCApproved) {
      this.pageForm.disable();
    }
  }

  subscribeToCountryChange() {
    if (!this.isOrganization) {
      this.pageForm.get('countryId').valueChanges.pipe(untilComponentDestroyed(this)).subscribe(countryId => {
        this.pageForm.get('stateName').setValidators(countryId === this.USCountryId ? Validators.required : []);
        this.pageForm.get('stateName').updateValueAndValidity();
      });
    }
  }

  conutryTrackByFn(index, item: CountryModel) {
    return item.id; // or index
  }

  save() {
    this.isSubmitted = true;
    this.isGeneralServerError = false;

    if (this.pageForm.valid) {
      const formValues = this.pageForm.value;
      const model = new PersonalDetailsReqRes();
      model.firstName = formValues.firstName;
      model.lastName = formValues.lastName;
      model.phone1 = formValues.phone1;

      if (!this.isOrganization) {
        model.countryId = formValues.countryId;
        model.stateName = formValues.stateName;
      }

      this.formSubmitting = true;
      this.userService.personalDetailsUpdate(model, UserType.Client).subscribe(
        response => {
          this.snackbarService.showGeneralMessage('Saved');
          this.formSubmitting = false;
        },
        error => {
          this.isGeneralServerError = true;
          this.formSubmitting = false;
          console.log('Error', error);
        }
      );
    }
  }
}
